import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

let items = document.getElementsByClassName('gasp-highlight-trigger');

gsap.from(".gasp-highlight-trigger-title", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gasp-highlight-trigger-title",
        start: 'top bottom',
        end: 'bottom center',
        markers: false,
        scrub: true
    },
    y: '100%',
});


gsap.from(".gasp-highlight-trigger-button", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gasp-highlight-trigger-button",
        start: 'bottom bottom',
        end: 'bottom +=85%',
        markers: false,
        scrub: true
    },
    opacity: 0
});

for (var i = items.length - 1; i >= 0; i--) {
    let scrub = 1 + ( i/items.length );

    gsap.from(items[i], {
        scrollTrigger: {
            toggleActions: "play none reverse none",
            trigger: '.gasp-highlight-trigger-title',
            start: 'top +=85%',
            end: 'bottom center',
            markers: false,
            scrub: 0.75 * i
        },
        opacity: 0,
        y: '2rem',
    });
};

